export default __webpack_public_path__ + "static/media/Yuki.24995a82.png";